import $ from "jquery";
import _ from "underscore";
import Backbone from "backbone";
import componentColor from "src/shared/components/component-color";

import bannerImage from "assets/components/banner.png";
import confirmationImage from "assets/components/confirmation.png";
import globalFooterImage from "assets/components/global_footer.png";
import globalHeaderImage from "assets/components/global_header.png";
import mobileMenuImage from "assets/components/mobile_menu.png";
import mobileNotificationImage from "assets/components/mobile_notification.png";
import overlayImage from "assets/components/overlay.png";
import productPageImage from "assets/components/product_page.png";

const IMAGES = {
    banner: bannerImage,
    confirmation: confirmationImage,
    global_footer: globalFooterImage,
    global_header: globalHeaderImage,
    mobile_menu: mobileMenuImage,
    mobile_notification: mobileNotificationImage,
    overlay: overlayImage,
    product_page: productPageImage,
};

const NORMALIZE_COMPONENT_NAME_PATTERN = /(_[0-9]+)*$/;
const PICK_ATTRIBUTES = [
    "name",
    "description",
    "tags",
    "variables",
    "component_version",
];
const PROGRAM_TYPE_PREFIX = "program-type:";
const PROMOTION_TYPE_PREFIX = "promotion-type:";
const TAGS = {
    PROGRAM_TYPE_PREFIX,
    PROGRAM_TYPE_GENERIC: `${PROGRAM_TYPE_PREFIX}generic`,
    PROMOTION: `${PROMOTION_TYPE_PREFIX}*`,
    PROMOTION_ONSITE: ["onsite-promotion", `${PROMOTION_TYPE_PREFIX}onsite`],
    PROMOTION_EMAIL: [
        "email-promotion",
        "type:email",
        `${PROMOTION_TYPE_PREFIX}email`,
    ],
    PROMOTION_LINK: [`${PROMOTION_TYPE_PREFIX}link`],
    PROMOTION_APP: [`${PROMOTION_TYPE_PREFIX}app`],
};
const PROMOTION_TYPE_TAGS = _.pick(
    TAGS,
    "PROMOTION_ONSITE",
    "PROMOTION_EMAIL",
    "PROMOTION_APP"
);
const PROMOTION_TYPES = {
    LINK: "LINK",
    EMAIL: "EMAIL",
    WEB: "WEB",
    APP: "APP",
};
const FLOW_STEP_TAG_PREFIX = "component-filter:type:";
const PROMOTION_TYPE_CONFIGURATIONS = {
    EMAIL: {
        type: PROMOTION_TYPES.EMAIL,
        tags: TAGS.PROMOTION_EMAIL,
        tagName: "PROMOTION_EMAIL",
        promotionTitle: "Email",
        promotionTypeName: "Email",
        promotionTypeListName: "Emails",
        flowStepTag: `${FLOW_STEP_TAG_PREFIX}email`,
    },
    WEB: {
        type: PROMOTION_TYPES.WEB,
        tags: TAGS.PROMOTION_ONSITE,
        tagName: "PROMOTION_ONSITE",
        promotionTitle: "Web",
        promotionTypeName: "On-Site Promotion",
        promotionTypeListName: "On-Site Promotions",
        flowStepTag: `${FLOW_STEP_TAG_PREFIX}onsite`,
    },
    APP: {
        type: PROMOTION_TYPES.APP,
        tags: TAGS.PROMOTION_APP,
        tagName: "PROMOTION_APP",
        promotionTitle: "In-App",
        promotionTypeName: "In-App Promotion",
        promotionTypeListName: "In-App Promotions",
        flowStepTag: `${FLOW_STEP_TAG_PREFIX}app`,
    },
};

function getPromotionTypeName(type) {
    const typeConfiguration = _.findWhere(PROMOTION_TYPE_CONFIGURATIONS, {
        tagName: type,
    });
    return typeConfiguration ? typeConfiguration.type : PROMOTION_TYPES.LINK;
}

function getPromotionTypeData(data) {
    const { tags } = data;
    let type;
    _.find(PROMOTION_TYPE_TAGS, (promotionTags, promotionType) => {
        const isFound = _.find(tags, (tag) => _.contains(promotionTags, tag));
        if (isFound) {
            type = promotionType;
        }
        return isFound;
    });
    type = type || "PROMOTION_LINK";
    return {
        promotion_type: type,
        promotion_type_name: getPromotionTypeName(type),
    };
}

const Component = {
    getName() {
        return this.get("name");
    },
    getDescription() {
        return this.get("description");
    },
    getCampaignId() {
        return this.get("campaign_id") || this.collection.getCampaignId();
    },
    getUpdatedDate() {
        return this.get("updated_date");
    },
    getTags() {
        return this.get("tags");
    },
    getColor() {
        return componentColor.get(this.getName());
    },
    getImageUrl() {
        const normalizedName = this.getName().replace(
            NORMALIZE_COMPONENT_NAME_PATTERN,
            ""
        );
        return IMAGES[normalizedName];
    },
    updateComponent(attributes) {
        const self = this;
        attributes.variables = _.map(attributes.variables, (variable) =>
            _.omit(variable, "value")
        );
        return Backbone.ajax({
            url: `/api/v2/campaigns/${this.getCampaignId()}/components/${
                this.id
            }`,
            type: "put",
            contentType: "application/JSON",
            data: JSON.stringify(_.pick(attributes, PICK_ATTRIBUTES)),
            success(newData) {
                return self.set(self.parse(newData));
            },
        });
    },
    sync(method, model, options) {
        if (method === "update") {
            return this.updateComponent(this.attributes);
        }
        if (method === "create") {
            options.attrs = _.omit(this.attributes, "promotion_type");
        }
        return Backbone.sync.call(this, method, model, options);
    },
    parse(data) {
        return _.extend(getPromotionTypeData(data), data);
    },
};

export default Component;
